import { Observable } from 'rxjs/Observable';
import { Customer, JobSite, Equipment } from '../global/model';
export class currentSelectionFiltered {
    public filteredCustomers: Customer[];
    public filteredJobsites: JobSite[];
}

export class FavoriteFormModel {
    public name: string;
    public backgroundColor: string = 'blue';
    public textColor: string = 'white';
}